import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, NavLink } from 'react-router-dom'
import { Button, Container, InputGroup, Input, InputGroupAddon, Row, Col, Badge, UncontrolledTooltip, Form, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import Pagination from "react-js-pagination";
import MaterialIcon from 'material-icons-react';
import i18n from "../../i18next";
import { AvField, AvForm, AvGroup } from 'availity-reactstrap-validation';

import {
	DEFAULT_PAGE_SIZE,
	DEFAULT_PAGING_RANGE,
	ONLINE,
	OFFLINE,
	PAUSED,
	NOT_CONFIGURED,
	OPEN,
	CLOSED,
	countryList,
	MENUU_ADMIN,
	LOW,
	MEDIUM,
	HIGH,
	INACTIVE
} from '../../utils/Constants';
import RestaurantUtils from '../../utils/RestaurantUtils';
import {
	isUserAllowedToAccessRestaurantBrand,
	isUserAllowedToAddBrands,
	localizeStatuses,
	localizeCountryNames
} from '../../utils/CommonUtils';
import {
	loadRestaurants,
	clearRestaurants,
	pauseRestaurant,
	createBrand,
	loadRestaurantsSummary,
	canUserAccessPauseAllRestaurants,
	resetUserAccessPauseAllRestaurants,
	downloadRestaurantsList
} from '../../actions/index';
import { loadNotifications } from "../../actions";
import CustomTable from "../common/CustomTable";
import SearchButton from '../common/SearchButton';

class RestaurantsScreen extends Component {

	constructor(props) {
		super(props);
		this.state = {
			advancedSearch: false,
			searchQuery: {
				brand: '',
				country: '',
				location: '',
				posType: '',
				posStatus: '',
				restaurantPriority: ''
			},
			currentPageNumber: 1,
			userCode: null,
			pauseAllModal: false,
			isOpen: false
		};

		this.changeState = this.changeState.bind(this);
		this.performSearch = this.performSearch.bind(this);
		this.changeCodeState = this.changeCodeState.bind(this);
		this.toggleModal = this.toggleModal.bind(this);
	}

	componentDidMount() {

		this.props.loadRestaurants();
		this.props.loadRestaurantsSummary();
	}

	componentWillUnmount() {
		this.props.clearRestaurants();
	}

	toggleSearch() {
		// toggling the search should reset the search query
		this.setState({
			advancedSearch: !this.state.advancedSearch,
			searchQuery: {
				brand: '',
				country: '',
				location: '',
				posType: '',
				posStatus: ''
			},
			currentPageNumber: 1
		});
		this.props.loadRestaurants();
	}

	changeState({ target }) {
		this.setState({
			searchQuery: {
				...this.state.searchQuery,
				[target.name]: target.value,
			}
		});
	}

	changeCodeState({ target }) {
		this.setState({
			...this.state,
			[target.name]: target.value
		});
	}

	search() {
		//new search should always start from page 1
		this.props.loadRestaurants(1, this.state.searchQuery);

		this.setState({
			currentPageNumber: 1
		});
	}

	clearSearch() {
		//new search should always start from page 1
		this.setState({
			searchQuery: {
				brand: '',
				country: '',
				location: '',
				posType: '',
				posStatus: ''
			},
			currentPageNumber: 1
		});
		this.props.loadRestaurants();
	}

	handlePageChange(pageNumber) {
		this.setState({
			currentPageNumber: pageNumber
		});
		this.props.loadRestaurants(pageNumber, this.state.searchQuery);
	}

	pause(event) {
		var restaurantPauseStatus = event.target.checked;
		var restaurantId = event.target.id;

		this.props.pauseRestaurant(restaurantPauseStatus, restaurantId, this.state.currentPageNumber, this.state.searchQuery);
	}

	keyPress(event) {
		if (event.keyCode === 13) { // this is Enter
			this.search();
		}
	}

	createBrand() {
		this.props.createBrand();
	}

	toggleModal() {
		this.setState({
			...this.state,
			isOpen: !this.state.isOpen,
			userCode: null
		});
	}

	renderPasswordVerification = () => {

		return (
			<AvForm onValidSubmit={() => this.props.canUserAccessPauseAllRestaurants(this.state.userCode)}>
				<AvGroup>
					<span className='codeVerification'><MaterialIcon icon="lock" size={20} color="#a9a9a9" />
						<AvField
							style={{ paddingLeft: 36 }}
							placeholder={i18n.t('screens:restaurantsScreen.secretCode')}
							type="password" name="userCode" id="password"
							value={this.state.userCode}
							onChange={this.changeCodeState}
							required
							errorMessage={i18n.t('common:validations.errorMsg')}
						/>
					</span>
				</AvGroup>
			</AvForm>
		);
	}

	renderRestaurantsTableRows() {
		if (this.props.restaurants.content !== undefined && this.props.restaurants.content !== null) {
			return this.props.restaurants.content.map((restaurant, i) => {

				const posStatusColor = RestaurantUtils.getPosStatusColor(restaurant.posStatus);
				const statusColor = RestaurantUtils.getStatusColor(restaurant.status);
				const posColor = { color: posStatusColor };
				const openClosedColor = { color: statusColor };

				const posStatusPaused = restaurant.posPaused;
				const disablePosStatusPaused = (restaurant.posStatus === NOT_CONFIGURED) ? true : ((restaurant.posStatus === OFFLINE) ? true : false);

				let key = { 'key': restaurant.restaurantId };
				let element;
				const { inputCheckbox, cursorPointer } = styles

				const userAllowedToAccessBrand = isUserAllowedToAccessRestaurantBrand(restaurant, this.props.currentlyLoggedInUser);

				if (userAllowedToAccessBrand) {
					element = (
						<td className="col-2">
							<NavLink id={restaurant.restaurantChainId}
								tag={Link}
								to={`/brand/${restaurant.restaurantChainId}`}
							>
								{restaurant.restaurantChainName}
							</NavLink>
							<span id={"restaurantName" + i} style={cursorPointer}>
								<a href={restaurant.webSite} target="_blank"><MaterialIcon icon="public" color="#0288D1" size={18} /></a>
							</span>
							<UncontrolledTooltip placement="top" target={"restaurantName" + i} >
								{i18n.t('screens:restaurantsScreen.linkTo')}{restaurant.restaurantChainName}{i18n.t('screens:restaurantsScreen.website')}
							</UncontrolledTooltip>
						</td>
					)
				} else {
					element = (
						<td className="col-2">
							{restaurant.restaurantChainName}
							<span id={"restaurantName" + i} style={cursorPointer}>
								<a href={restaurant.webSite} target="_blank"><MaterialIcon icon="public" color="#0288D1" size={18} /></a>
							</span>
							<UncontrolledTooltip placement="top" target={"restaurantName" + i} >
								{i18n.t('screens:restaurantsScreen.linkTo')}{restaurant.restaurantChainName}{i18n.t('screens:restaurantsScreen.website')}
							</UncontrolledTooltip>
						</td>
					)
				}

				return (
					<tr {...key} className="d-flex">
						<td className="col-1">{restaurant.country}</td>
						{element}
						<td className="col-3">
							<NavLink id={restaurant.restaurantId}
								tag={Link}
								to={`/restaurant/${restaurant.restaurantId}/settings/general`}
							>{restaurant.location}</NavLink>
						</td>
						<td className="col-2">{restaurant.phone}</td>
						<td className="col-1">{restaurant.posType}</td>
						<td className="col-1" style={openClosedColor}>{localizeStatuses(restaurant.status)}</td>
						<td className="col-1" style={posColor}>{localizeStatuses(restaurant.posStatus)}</td>
						<td className="col-1">
							<Input type="checkbox" style={inputCheckbox} id={restaurant.restaurantId}
								name={restaurant.restaurantId} checked={posStatusPaused} disabled={disablePosStatusPaused}
								onChange={this.pause.bind(this)} />
						</td>
					</tr>
				);
			});

		}
	}

	renderAddBrand() {
		const userAllowedToAddBrands = isUserAllowedToAddBrands(this.props.currentlyLoggedInUser);
		if (userAllowedToAddBrands) {
			return (
				<Button color="primary" onClick={this.createBrand.bind(this)}> <MaterialIcon icon="add_circle_outline" color="#fff" size={20} />&nbsp;{i18n.t('common:buttons.addBrand')}</Button>
			);
		} else {
			return (
				<span></span>
			);
		}
	}

	renderSimpleSearch() {
		const { flexEnd, inputGroupSearch, inputSearch, paddingLeftRight, rowMarginTop, simpleSearchPipe,
			inputGroupAddon, cursorPointer } = styles;
		const { brand } = this.state.searchQuery;

		return (
			<div>
				<Row>
					<Col xs="auto" sm={10} >
						<Row>
							<Col xs={4} style={paddingLeftRight}>
								<InputGroup style={inputGroupSearch}>
									<Input
										type="text" name="brand" id="brand" placeholder={i18n.t('screens:restaurantsScreen.brand')} value={brand}
										onChange={this.changeState}
										onKeyDown={this.keyPress.bind(this)} style={inputSearch} />
									<InputGroupAddon addonType="append" style={inputGroupAddon}>
										<div onClick={this.search.bind(this)} style={cursorPointer} ><MaterialIcon icon="search" color="#0288D1" size={28} /></div>
									</InputGroupAddon>
								</InputGroup>
							</Col>
						</Row>
					</Col>
					<Col xs={2} style={flexEnd}>
						<div>{this.renderAddBrand()}</div>
					</Col>
				</Row>
				<Row style={rowMarginTop}>
					<Col xs={10}>
						<Row>
							<Col xs={4} style={flexEnd}>
								<Button color="link" onClick={this.clearSearch.bind(this)}>{i18n.t('common:searchForms.clear')}</Button>
								<span style={simpleSearchPipe}>|</span>
								<Button color="link" onClick={this.toggleSearch.bind(this)}>{i18n.t('common:searchForms.advancedSearch')}</Button>
							</Col>
						</Row>
					</Col>
				</Row>
			</div>
		);
	}

	onKeyUp(event) {
		event.preventDefault();
		if (event.keyCode === 13) {
			document.getElementById('advanceSearchButton').click();
		}
	}

	renderAdvancedSearch() {
		const { flexEnd, paddingLeftRight, posStyle,
			rowMarginTop, advancedSearchPipe } = styles;

		const { brand, country, location, posType, posStatus, restaurantPriority } = this.state.searchQuery;

		const isUserIsAdminOrMasterAdmin = isUserAllowedToAddBrands(this.props.currentlyLoggedInUser);

		return (
			<div>
				<Row>
					<Col xs="auto" sm={10} >
						<Form id='advanceSearchForm' onKeyUp={this.onKeyUp}>
							<Row>
								<Col style={paddingLeftRight}>
									<Input type="text" name="brand" id="brand" placeholder={i18n.t('screens:restaurantsScreen.brand')} value={brand} onChange={this.changeState} />
								</Col>
								<Col style={paddingLeftRight}>
									<Input
										type="select" name="country" id="country" placeholder={i18n.t('screens:restaurantsScreen.country')}
										value={country}
										onChange={this.changeState}
									>
										<option value="">{i18n.t('common:validations.chooseCountry')}</option>
										{this.renderCountryOptions()}
									</Input>
								</Col>
								<Col style={paddingLeftRight}>
									<Input type="text" name="location" id="location" placeholder={i18n.t('screens:restaurantsScreen.location')} value={location} onChange={this.changeState} />
								</Col>
								<Col style={posStyle}>
									<Input type="text" name="posType" id="posType" placeholder={i18n.t('screens:restaurantsScreen.posType')} value={posType} onChange={this.changeState} />
								</Col>
								<Col style={posStyle}>
									<Input type="select" name="posStatus" id="posStatus" placeholder={i18n.t('screens:restaurantsScreen.posStatus')} value={posStatus} onChange={this.changeState} >
										<option value="">{i18n.t('screens:restaurantsScreen.posStatus')}</option>
										<option value={ONLINE}>{i18n.t('screens:restaurantsScreen.online')}</option>
										<option value={OFFLINE}>{i18n.t('screens:restaurantsScreen.offline')}</option>
										<option value={NOT_CONFIGURED}>{i18n.t('screens:restaurantsScreen.notConfigured')}</option>
										<option value={INACTIVE}>{i18n.t('screens:restaurantsScreen.inactiveRestaurants')}</option>
										<option value={PAUSED}>{i18n.t('screens:restaurantsScreen.paused')}</option>
									</Input>
								</Col>
								{
									isUserIsAdminOrMasterAdmin &&

									<Col style={posStyle}>
										<Input type="select" name="restaurantPriority" id="restaurantPriority" value={restaurantPriority} onChange={this.changeState} >
											<option value="">{i18n.t('screens:generalScreen.priorityLevel')}</option>
											<option value={LOW}>{i18n.t('screens:generalScreen.low')}</option>
											<option value={MEDIUM}>{i18n.t('screens:generalScreen.medium')}</option>
											<option value={HIGH}>{i18n.t('screens:generalScreen.high')}</option>
										</Input>
									</Col>
								}
								<Col>
									<SearchButton search={this.search.bind(this)} />
								</Col>
							</Row>
						</Form>
					</Col>
					<Col xs={2} style={flexEnd}>
						<div>{this.renderAddBrand()}</div>
					</Col>
				</Row>
				<Row style={rowMarginTop}>
					<Col xs={10} style={flexEnd}>
						<Button color="link" onClick={this.clearSearch.bind(this)}>{i18n.t('common:searchForms.clear')}</Button>
						<span style={advancedSearchPipe}>|</span>
						<Button color="link" onClick={this.toggleSearch.bind(this)}>{i18n.t('common:searchForms.simpleSearch')}</Button>
					</Col>
				</Row>
			</div>
		);
	}

	renderCountryOptions() {
		return countryList.map((country, i) => {
			return <option key={i} value={country}>{localizeCountryNames(country)}</option>
		});
	}

	renderRestaurantSummary() {
		const { restaurantSummary, cursorPointer, inactiveBadgeColor } = styles;
		const { onlineCount, offlineCount, pausedCount, notConfiguredCount, openRestaurantsCount, closedRestaurantsCount, inactiveRestaurantsCount } = this.props.restaurantsSummary;

		const colorOnline = { color: "#759F2E" }, colorOffline = { color: "#BF1E2E" }, colorPaused = { color: "#FF990A" }, colorDefault = { color: "#000" }, colorInactiveRestaurant = { color: "#757575" }
		
		return (
			<Col xs={12} sm="auto" md={8} lg={5} style={restaurantSummary}>
				<span style={cursorPointer} onClick={() => this.performSearch(ONLINE)} ><p style={colorOnline}>{i18n.t('screens:restaurantsScreen.online')}: <Badge color="success">{onlineCount}</Badge></p></span>
				<span style={cursorPointer} onClick={() => this.performSearch(OFFLINE)} ><p style={colorOffline}>{i18n.t('screens:restaurantsScreen.offline')}: <Badge color="danger">{offlineCount}</Badge></p></span>
				<span style={cursorPointer} onClick={() => this.performSearch(PAUSED)} ><p style={colorPaused}>{i18n.t('screens:restaurantsScreen.paused')}: <Badge color="warning">{pausedCount}</Badge></p></span>
				<span style={cursorPointer} onClick={() => this.performSearch(NOT_CONFIGURED)} ><p style={colorDefault}>{i18n.t('screens:restaurantsScreen.notConfigured')}: <Badge color="secondary">{notConfiguredCount}</Badge></p></span>
				<span style={cursorPointer} onClick={() => this.performSearch(INACTIVE)} ><p style={colorInactiveRestaurant}>{i18n.t('screens:restaurantsScreen.inactiveRestaurants')}: <Badge style={inactiveBadgeColor}>{inactiveRestaurantsCount}</Badge></p></span>
				{/* <span style={cursorPointer} onClick={() => this.performSearch(OPEN)}><p style={colorOnline}>{i18n.t('common:statuses.open')}: <Badge color="success">{openRestaurantsCount}</Badge></p></span> */}
				{/* <span style={cursorPointer} onClick={() => this.performSearch(CLOSED)}><p style={colorOffline}>{i18n.t('common:statuses.closed')}: <Badge color="danger">{closedRestaurantsCount}</Badge></p></span> */}
			</Col>
		);
	}

	performSearch(target) {
		// this.setState({  // TODO works with one click delay !
		// 	searchQuery: {
		// 		posStatus: target
		// 	}
		// });
		if (target === OPEN || target === CLOSED) {
			this.state.searchQuery.workingStatus = target;
		} else {
			this.state.searchQuery.posStatus = target;
		}

		this.props.loadRestaurants(1, this.state.searchQuery);

		this.setState({
			currentPageNumber: 1
		});
	}

	render() {
		const { containerStyle, flexEnd } = styles;
		return (
			<Container fluid style={containerStyle}>
				{!this.state.advancedSearch ? this.renderAdvancedSearch() : this.renderSimpleSearch()}
				<Row>
					{this.renderRestaurantSummary()}
				</Row>
				{
					this.props.restaurants.content.length !== 0 ?
						<CustomTable
							styles={styles}
							tableName='restaurantsTable'
							tableData={this.props.restaurants.content}
							currentUser={this.props.currentlyLoggedInUser}
							handlePause={this.pause.bind(this)} />
						:
						<Row></Row>
				}
				<Row>
					{
						(this.props.currentlyLoggedInUser.role === 'MENUU_MASTER_ADMIN' || this.props.currentlyLoggedInUser.role === MENUU_ADMIN) &&
						<Button
							color='primary'
							style={{
								padding: '4px 5px',
								height: 30
							}}
							onClick={() => this.toggleModal()}>{i18n.t('screens:restaurantsScreen.downloadRestaurants')}</Button>
					}
					<Col style={flexEnd}>
						<Pagination
							activePage={this.props.restaurants.number + 1}
							itemsCountPerPage={DEFAULT_PAGE_SIZE}
							totalItemsCount={this.props.restaurants.totalElements}
							pageRangeDisplayed={DEFAULT_PAGING_RANGE}
							itemClass='page-item'
							linkClass='page-link'
							onChange={this.handlePageChange.bind(this)}
						/>
					</Col>
				</Row>
				{
					this.state.isOpen ?
						<Modal isOpen={this.state.isOpen} toggle={this.toggleModal}>
							<ModalHeader className="modalHeader" toggle={this.toggleModal}>
								{i18n.t('screens:restaurantsScreen.enterSecretCode')}
							</ModalHeader>
							<ModalBody>
								{this.renderPasswordVerification()}
							</ModalBody>
							<ModalFooter>
								<Button
									color="primary"
									onClick={() => this.props.canUserAccessPauseAllRestaurants(this.state.userCode,
										() => this.props.downloadRestaurantsList(() => {
											this.props.resetUserAccessPauseAllRestaurants();
											this.toggleModal();
										}))}>
									<MaterialIcon icon="check" color="#fff"
										size={20} />&nbsp;{i18n.t('common:buttons.confirm')}
								</Button>
								<Button color="outline-primary" onClick={this.toggleModal}>{i18n.t('common:buttons.cancel')}</Button>
							</ModalFooter>
						</Modal> : null
				}
			</Container>
		);
	}
}

const mapStateToProps = state => {

	return {
		currentlyLoggedInUser: state.user,
		restaurants: state.restaurants,
		brand: state.brand,
		restaurantsSummary: state.restaurantsSummary,
		user: state.user
	}
};

export default connect(mapStateToProps, {
	loadRestaurants,
	clearRestaurants,
	pauseRestaurant,
	createBrand,
	loadRestaurantsSummary,
	loadNotifications,
	canUserAccessPauseAllRestaurants,
	resetUserAccessPauseAllRestaurants,
	downloadRestaurantsList
})(RestaurantsScreen);

let styles = {
	containerStyle: {
		width: '96%',
		marginTop: 20
	},
	flexEnd: {
		display: 'flex',
		justifyContent: 'flex-end',
		paddingRight: 0
	},
	inputGroupSearch: {
		border: '1px solid lightgray'
	},
	inputSearch: {
		border: 0
	},
	searchIcon: {
		marginTop: '-3px',
		position: 'absolute'
	},
	paddingLeftRight: {
		paddingLeft: 5,
		paddingRight: 5
	},
	rowMarginTop: {
		marginBottom: 20
	},
	advancedSearchPipe: {
		height: 46,
		textAlign: 'center',
		verticalAlign: 'middle',
		padding: '10px 0',
		color: '#007bff'
	},
	simpleSearchPipe: {
		height: 46,
		textAlign: 'center',
		verticalAlign: 'middle',
		padding: '10px 0',
		color: '#007bff'
	},
	zeroPaddingRight: {
		paddingRight: 0
	},
	inputGroupAddon: {
		marginTop: '10px'
	},
	inputCheckbox: {
		marginLeft: '20px'
	},
	cursorPointer: {
		cursor: 'pointer'
	},
	posStyle: {
		paddingLeft: 5,
		paddingRight: 5
	},
	restaurantSummary: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between'
	},
	emailOverflow: {
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis'
	},
	inactiveBadgeColor: {
		backgroundColor: '#D3D3D3',
		color: '#000000'
	}
}


// WEBPACK FOOTER //
// ./src/components/restaurants/RestaurantsScreen.js